import { render, staticRenderFns } from "./kpi.vue?vue&type=template&id=317537bd&scoped=true"
import script from "./kpi.vue?vue&type=script&lang=js"
export * from "./kpi.vue?vue&type=script&lang=js"
import style0 from "./kpi.vue?vue&type=style&index=0&id=317537bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317537bd",
  null
  
)

export default component.exports